import { DataTable, Heading, Loader } from "@/components";
import { Button, Input } from "@/components/ui";
import useUsersList from "./useUsersList";
import { Search } from "lucide-react";

const UsersList = () => {
  const {
    globalFilter,
    setGlobalFilter,
    columns,
    isLoadingCommunityUsers,
    communityUsers,
    onCancel
  } = useUsersList();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="User List" />
        </div>
        <div className="flex flex-row items-center gap-4">
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
        </div>
      </div>

      {/* Responsive Table */}
      {isLoadingCommunityUsers ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={
              communityUsers?.data?.sort((a: any, b: any) => {
                if (a.endDate === null && b.endDate !== null) return -1;
                if (a.endDate !== null && b.endDate === null) return 1;
                return 0;
              }) || []
            }
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
          />
          <div className="flex flex-row justify-end gap-3  py-3">
            <Button variant="outline" type="button" onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default UsersList;
